import { render } from "./chat.vue?vue&type=template&id=5e076f41"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=5e076f41&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__